import { clampOpordTasksActionCount } from 'components/DisasterGPT/constants/opordSectionDefaults';

/**
 * Copy shown in section settings for an automated provider. Seerist is named
 * only for that provider.
 */
export function describeAutomatedProvider(
  provider: string | undefined
): string {
  switch (provider) {
    case 'layerStats':
      return 'Provider: Layer stats. Configure Layers and datetime in the section body (or below), then Run Analytics.';
    case 'actions':
      return 'Lists org and incident tasks inside the report area. Use Run Tasks in the section body.';
    case 'orgEvents':
      return 'Lists events inside the report area. Use Run Events in the section body.';
    case 'incidents':
      return 'Lists incidents inside the report area. Use Run Incidents in the section body.';
    case 'childAorReport':
      return 'Includes a snapshot of a child area of responsibility. Configure it in the section body.';
    case 'seerist':
      return 'Provider: Seerist. Configure the request and query params in the section body, then use Send request.';
    default:
      return 'Automated section. Configure it in the section body.';
  }
}

export const DEFAULT_AI_TASK_INSTRUCTIONS =
  'Propose concrete Planned tasks a response team would execute, grounded in the selected context.';

export type AiTasksSettings = {
  enabled: boolean;
  data_sources: unknown[];
  instructions: string;
  action_count: number;
};

/** Saved on output_format_structured.ai_tasks. Saving does not create tasks. */
export function buildAiTasksSettings(values: {
  enabled: boolean;
  dataSources: unknown[];
  instructions: string;
  actionCount: number;
}): AiTasksSettings {
  return {
    enabled: values.enabled === true,
    data_sources: Array.isArray(values.dataSources) ? values.dataSources : [],
    instructions: values.instructions ?? '',
    action_count: clampOpordTasksActionCount(values.actionCount),
  };
}
